/* TEST
export const HERA_TOKEN = "0x8eCb40ca1a24e2Cac654c2778eeff15338e86ED2";
export const EXPLORER_URL = "https://stardust-explorer.metis.io/"
export const RPC_URL = "https://stardust.metis.io/"
export const MULTICALLADDR = "0xd0e29700d8dDF9b069907836a1CBdA513b2Ed3f8"
export const CHAINID = 588
*/
/* METIS*/
export const HERA_TOKEN = "0x6F05709bc91Bad933346F9E159f0D3FdBc2c9DCE";
export const EXPLORER_URL = "https://andromeda-explorer.metis.io/"
export const RPC_URL = "https://andromeda.metis.io/"
export const MULTICALLADDR = "0xe04A9567742d7c15D9A0a6ef51C19Eaec625b861"
export const CHAINID = 1088
 
export const LOCKTIME = 60 * 60 * 24 * 7
/*{ 0x2508965Ec75498c451B9e325B7A09288f27762D8
      contract: "0x1",
      type: 2,
      isActive: false,
      isStaked: true,
      name: "Farm",
      tokenName: "NLP",
      imgUrl: "assets/images/icons/hera-hera.png",
},*/   

export const STAKE_CONTRACTS = [
  
  {
    contract: "0x2ec37306801cb2dce6526C71b28916a70a835C03",
    type: 1,
    startTime: 1651325400,
    finishTime: 1656595800,
    isActive: false,
    isStaked: false,
    name: "Single Stake",
    tokenName: "HERA",
    imgUrl: "assets/images/icons/hera-hera.png",
    buyUrl: "https://app.hera.finance/#/swap?outputCurrency=0x6F05709bc91Bad933346F9E159f0D3FdBc2c9DCE",
    buyUrlText: "Buy Hera Token"
  },
  {
    contract: "0x2508965Ec75498c451B9e325B7A09288f27762D8",
    type: 1,
    startTime: 1656610200,
    finishTime: 1695029400,
    isActive: true,
    isStaked: false,
    name: "Single Stake",
    tokenName: "HERA",
    imgUrl: "assets/images/icons/hera-hera.png",
    buyUrl: "https://app.hera.finance/#/swap?outputCurrency=0x6F05709bc91Bad933346F9E159f0D3FdBc2c9DCE",
    buyUrlText: "Buy Hera Token"
  },
];
